import { render, staticRenderFns } from "./StockPreview.vue?vue&type=template&id=b5b68aa6&scoped=true&"
import script from "./StockPreview.vue?vue&type=script&lang=js&"
export * from "./StockPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b68aa6",
  null
  
)

export default component.exports